import {getGsmResultList, getSpectrumViewerData} from "../graphql/queries";
import {updateStructureAnnotation} from "../graphql/mutations"
import {API, graphqlOperation} from "aws-amplify";

export const SET_ANNOTATED_GSM_RESULT_LIST = "SET_ANNOTATED_GSM_RESULT_LIST";
export const SET_SPECTRUM_VIEWER_DATA = "SET_SELECTED_SPECTRUM";

export function setGsmResults(annotatedGsmResultList) {
    return {
        type: SET_ANNOTATED_GSM_RESULT_LIST,
        annotatedGsmResultList
    }
}

export function setSelectedSpectrum(spectrum) {

    return {
        type: SET_SPECTRUM_VIEWER_DATA,
        spectrum: spectrum
    }
}

export function fetchGsmResultDetails(gsmResult) {

    if (gsmResult.composition === "-") {

        return (dispatch) => {

            dispatch(setGsmResults(undefined));
        }
    } else {
        return (dispatch) => {

            dispatch(setGsmResults(undefined));

            API.graphql(
                graphqlOperation(getGsmResultList, gsmResult)
            ).then(result => {
                return {
                    ...result.data.getGsmResultList,
                    projectId: gsmResult.projectId,
                    runId: gsmResult.runId,
                    preClusterId: gsmResult.preClusterId,
                    clusterId: gsmResult.clusterId,
                    massGroup: gsmResult.massGroup
                };
            }).then(
                result => dispatch(setGsmResults(result))
            ).catch((e) => {
                console.log("There was an error fetching the result details", gsmResult);
                console.log(e);
            });
        }
    }
}

export function updateAnnotation(variables){
    return (dispatch) => {
        API.graphql(
            graphqlOperation(updateStructureAnnotation, variables)
        ).then(result => {
            return {
                ...result.data.updateStructureAnnotation,
                projectId: variables.projectId,
                runId: variables.runId,
                preClusterId: variables.preClusterId,
                clusterId: variables.clusterId,
                massGroup: variables.massGroup
            };
        }).then(
            result => dispatch(setGsmResults(result))
        ).catch(e => {
            console.log(e);
        })
    }
}

export function fetchSpectrumViewerData(gsmResult) {

    let query = {
        projectId: gsmResult.projectId,
        runId: gsmResult.runId,
        preClusterId: gsmResult.preClusterId,
        clusterId: gsmResult.clusterId,
        numberOfPeaks: 100
    };

    return (dispatch) => {

        dispatch(setSelectedSpectrum({
            peaks:[]
        }));

        API.graphql(
            graphqlOperation(getSpectrumViewerData, query)
        ).then(result => {
            dispatch(setSelectedSpectrum(result.data.getSpectrumViewerData))
        }).catch((e) => {
            console.log("There was an error fetching the spectrum data");
            console.log(e);
        });
    }
}